import React from "react";
import { useState,useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WestIcon from "@mui/icons-material/West";
import CloseIcon from "@mui/icons-material/Close";
import "./DeliveryInvoiceEdit.css";
import { DeliveryInvoiceBatchDetails, DeliveryInvoiceSkuDetails, SalesReasonDetails } from "../../types/types";
import DeliveryInvoiceReasonSelectionParent from "./DeliveryInvoiceReasonSelectionParent";
import BatchListItem from "./BatchListItem";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { getAllProductDetailsFromDb, getBatchDetailsFromDb, setBatchDetailsInDb } from "../SalesReturn/SalesReturnService";


const SkuDetailsEdit: React.FC = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [expandedBatch, setExpandedBatch] = useState<DeliveryInvoiceBatchDetails | null>(null);
//   const { batchDetails } = useSelector((state: {collections:CollectionsState}) => state.collections);
  const showReturnQty = location.state?.showReturnQty;
  const [editedDetails, setEditedDetails] = useState<DeliveryInvoiceBatchDetails[]>([]);
  const selectedRowToEdit:DeliveryInvoiceSkuDetails | null = location.state?.rowData;
  const batchDetails:{[key: string]: SalesReasonDetails[]} = location.state?.batchDetails;
  const isRestrictedSku:boolean = location.state?.isRestrictedSku;
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const { otherUnitLabel } = ConfigDictionary;
  const [disabledUoms, setDisabledUoms] = useState<string[]>([]);
  const currency = ConfigDictionary?.currency;

  useEffect(() => {
    if(!selectedRowToEdit){
      navigate(-1);
      return;
    }
    const selectedBatchData:{[key:string]:SalesReasonDetails[]} = batchDetails;
    let newBatchDetails:DeliveryInvoiceBatchDetails[] = selectedRowToEdit?.batchIds.map((row)=>{
      return {
        batchId: row.batchId,
        caseQty: row.caseQty,
        otherQty: row.otherQty,
        pieceQty: row.pieceQty
      };
    }) ?? [];
    newBatchDetails.forEach((batchData)=>{
      batchData.reasonDetails = selectedBatchData[batchData.batchId];
    })
    setEditedDetails(newBatchDetails);
    setExpandedBatch(null);
    
  }, []);

  const handleOnClose = () => {
    navigate(-1);
  };

  const filterReasonDetails = (reasons:SalesReasonDetails[])=>{
    return reasons.filter(reasonDetail=>{
      const qty = reasonDetail.caseQty+reasonDetail.otherQty+reasonDetail.pieceQty;
      if(qty>0 && reasonDetail.reason){
        return true;
      }
      if(qty>0 && !reasonDetail.reason){
        openPopup("Error", "Please add reasons for returns");
        throw Error("reason details not added");
      }
      return false;
    });
  }
  const handleOnSubmit = async()=>{
    const newBatchDetails = (await getBatchDetailsFromDb("salesReturnWithInvoice")) ?? {};
    if(selectedRowToEdit!=null){
      newBatchDetails[selectedRowToEdit.batchCode] = newBatchDetails[selectedRowToEdit.batchCode] ?? {};
      editedDetails.forEach(batch=>{
        const reasons = batch.reasonDetails??[];
        const filteredReasons = groupByReason(filterReasonDetails(reasons));
        newBatchDetails[selectedRowToEdit.batchCode][batch.batchId] = filteredReasons;
      })

      await setBatchDetailsInDb(newBatchDetails, "salesReturnWithInvoice");
    }
    handleOnClose()
  }
  function groupByReason(items: SalesReasonDetails[]): SalesReasonDetails[] {
    const groupedMap = items.reduce((acc, current) => {
      // If the reason doesn't exist in the map, initialize it
      if (!acc[current.reason]) {
        acc[current.reason] = {
          reason: current.reason,
          caseQty: 0,
          pieceQty: 0,
          otherQty: 0,
          saleCondition: current.saleCondition
        };
      }
      
      // Sum the quantities
      acc[current.reason].caseQty += current.caseQty;
      acc[current.reason].pieceQty += current.pieceQty;
      acc[current.reason].otherQty += current.otherQty;
      
      return acc;
    }, {} as Record<string, SalesReasonDetails>);
  
    // Convert the map back to an array
    return Object.values(groupedMap);
  }

  const handleReset = () => {
    let newBatchDetails:DeliveryInvoiceBatchDetails[] = selectedRowToEdit?.batchIds.map((row)=>{
      return {
        batchId: row.batchId,
        caseQty: row.caseQty,
        otherQty: row.otherQty,
        pieceQty: row.pieceQty,
      };
    }) ?? [];
    setEditedDetails(newBatchDetails);
    // selectedRowToEdit?.batchIds?.forEach(batchObject=>delete batchObject.reasonDetails);
    setExpandedBatch(null);
    // setStaticBatches(selectedRowToEdit?.batchIds || []);
  };

  const handleChangeExpandedBatch = async (batch: DeliveryInvoiceBatchDetails) => {
    try{
      const productDetails = await getAllProductDetailsFromDb();
      const skuCode = selectedRowToEdit?.batchCode;
      if(productDetails && skuCode && productDetails[skuCode] && productDetails[skuCode].otherUnitToPieceQuantity == 0){
        setDisabledUoms(["otherQty"]);
      }else{
        setDisabledUoms([]);
      }
      
    }catch(error){
        console.log(error);
    }
    setExpandedBatch((prevState: DeliveryInvoiceBatchDetails | null) =>
      prevState?.batchId === batch?.batchId ? null : batch
    );
  };

  useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
        event.preventDefault();
        if (selectedRowToEdit) {
          try {
            handleOnSubmit();
          } catch (e) {
            // Error handled by filterReasonDetails via openPopup
          }
        }
      } else if ((event.ctrlKey || event.metaKey) && (event.key === 'x' || event.key === 'z')) {
        event.preventDefault();
        handleReset();
      }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [selectedRowToEdit, handleOnSubmit, handleReset]);

  return (
    <div className="edit-return-container">
      <header>
        <div>
          <WestIcon style={{ cursor: "pointer" }} onClick={() => navigate(-1)} />
          <p> Add Return Qty for {selectedRowToEdit?.skuName} ({selectedRowToEdit?.batchCode}) </p>
        </div>
        <CloseIcon style={{ cursor: "pointer" }} onClick={handleOnClose} />
      </header>
      <div className="edit-return-model-container">
        <div className="inside-header">
            <div className="inside-header-container">
                <div className="inside-header-label">SKU Code</div>
                <div className="inside-header-value">{selectedRowToEdit?.batchCode}</div>
            </div>

            <div className="inside-header-container">
                <div className="inside-header-label">SKU Name</div>
                <div className="inside-header-value">{selectedRowToEdit?.skuName}</div>
            </div>

            <div className="inside-header-container">
                <div className="inside-header-label">{showReturnQty ? "Return Qty" : "Returnable Qty"}</div>
                <div className="value-group">
                    <div className="inside-header-value">{showReturnQty ? selectedRowToEdit?.returnCaseQty : selectedRowToEdit?.totalCaseQty} Cs</div>
                    {otherUnitLabel && <div className="inside-header-value">{showReturnQty ? selectedRowToEdit?.returnOtherQty : selectedRowToEdit?.totalOtherQty} {selectedRowToEdit?.otherUnitName ? selectedRowToEdit?.otherUnitName : "Other"}</div>}
                    <div className="inside-header-value">{showReturnQty ? selectedRowToEdit?.returnPieceQty : selectedRowToEdit?.totalPieceQty} Pc</div>
                </div>
            </div>
        </div>
        {isRestrictedSku && (
              <div className= "sku-detail-unselable-warning"  style={{
                margin: "0px 0px 15px 95px",
               
            }}>
                *This product cannot be returned as “Unsaleable” as per company’s policy.
              </div>
          )}
        <div className="inside-body">
            <div className="batch-id-text-delivery">
                Batch ID
            </div>
            <div className="edit-left">
                <div className="batches-list-container-delivery">
                    <div className="batch-list-heading">
                        <span>Select a batch ID to add damage quantity</span>
                    </div>
                    <div className="batches-list-delivery">
                      {editedDetails.length ? editedDetails.map((batch) => {
                        return (
                            <BatchListItem
                                key={batch.batchId}
                                batch={batch}
                                isSelected={expandedBatch?.batchId === batch.batchId}
                                onSelect={() => handleChangeExpandedBatch(batch)}
                                otherUnitName={selectedRowToEdit?.otherUnitName}
                            />
                        );
                      }):
                      <div className="batch-list-heading center">
                          <span>No Batch ID</span>
                      </div>
                      }
                    </div>
                </div>
            </div>
            {expandedBatch?.batchId && (
            <div className="edit-right-delivery">
            <div className="edit-right-delivery-top">
              <div className="edit-right-delivery-top-header">
                  <div style={{display: "flex", gap: "16px"}}>
                      <p className="batch-id-nos-delivery">{expandedBatch.batchId}</p>
                      {expandedBatch.mrp && <p className="batch-id-nos-delivery-mrp">(MRP:  {currency} {expandedBatch.mrp})</p>}
                  </div>
                  {expandedBatch.expiryDate && <p className="batch-id-nos-delivery-expiry-date">Expiry Date: {expandedBatch.expiryDate}</p>}
              </div>
              <div className="batch-ids-container-delivery">
                <div className="reasons-parent-delivery">
                  <DeliveryInvoiceReasonSelectionParent disabledUoms={disabledUoms} batchData={expandedBatch} otherUnitName={selectedRowToEdit?.otherUnitName} isRestrictedSku={isRestrictedSku}/>
                </div>
              </div>
            </div>
          </div>
            )}
        </div>
      </div>
      <footer>
        <button className="button-reset-delivery" onClick= {handleReset}>
          <span className="button-reset-delivery-text">Reset</span>
        </button>
        <button className="button-save-delivery" onClick={() => {handleOnSubmit();}}>
          <span className="button-save-delivery-text" >Submit</span>
        </button>
      </footer>
    </div>
  );
};

export default SkuDetailsEdit;
